import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, text, image, children, compact = false }) => (
  <section className={`relative bg-ink text-cream overflow-hidden ${compact ? "pt-40 pb-20 md:pt-48 md:pb-24" : "pt-44 pb-24 md:pt-56 md:pb-32"}`}>
    {image && (
      <motion.img
        src={image}
        alt=""
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 img-cover opacity-40"
        fetchPriority="high"
      />
    )}
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/20" />
    <div className="container-hh relative">
      {eyebrow && <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="eyebrow mb-6">{eyebrow}</motion.div>}
      <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.1 }} className="h-display max-w-4xl">{title}</motion.h1>
      {text && <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.25 }} className="lead !text-cream/80 max-w-2xl mt-8">{text}</motion.p>}
      {children}
    </div>
  </section>
);
